(function () {
  if (window.__gfeelSectionsLoaded) return;
  window.__gfeelSectionsLoaded = true;

  var heroIndex = 0;
  var heroTimer = null;
  var benefitTimer = null;
  window.bIdx = 0;

  function initParticles() {
    var wrap = document.getElementById('pts');
    if (!wrap || wrap.dataset.ready === 'true') return;
    wrap.dataset.ready = 'true';
    for (var i = 0; i < 22; i++) {
      var particle = document.createElement('div');
      var size = Math.random() * 3 + 0.8;
      particle.className = 'pt';
      particle.style.cssText =
        'width:' + size + 'px;height:' + size + 'px;left:' +
        Math.random() * 100 + '%;bottom:' + Math.random() * 55 +
        '%;animation-duration:' + (Math.random() * 7 + 5) +
        's;animation-delay:' + Math.random() * 10 + 's;';
      wrap.appendChild(particle);
    }
  }

  function initReveal() {
    var elements = document.querySelectorAll('.rev,.rev2,.rev-l,.rev-r');
    if (!('IntersectionObserver' in window)) {
      elements.forEach(function (element) { element.classList.add('in'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    elements.forEach(function (element) {
      if (!element.classList.contains('in')) observer.observe(element);
    });
  }

  window.heroGo = function (number) {
    var slides = document.querySelectorAll('#hero .h-slide');
    var dots = document.querySelectorAll('#hero .h-sdot');
    if (!slides.length || !dots.length) return;
    slides[heroIndex] && slides[heroIndex].classList.remove('active');
    dots[heroIndex] && dots[heroIndex].classList.remove('on');
    heroIndex = (number + slides.length) % slides.length;
    slides[heroIndex].classList.add('active');
    dots[heroIndex] && dots[heroIndex].classList.add('on');
  };

  function initHero() {
    var wrap = document.getElementById('heroSlider');
    if (!wrap || wrap.dataset.ready === 'true') return;
    wrap.dataset.ready = 'true';
    function start() {
      clearInterval(heroTimer);
      heroTimer = setInterval(function () { window.heroGo(heroIndex + 1); }, 5000);
    }
    function stop() { clearInterval(heroTimer); }
    wrap.addEventListener('mouseenter', stop);
    wrap.addEventListener('mouseleave', start);
    var touchX = 0;
    wrap.addEventListener('touchstart', function (event) {
      touchX = event.touches[0].clientX;
      stop();
    }, { passive: true });
    wrap.addEventListener('touchend', function (event) {
      var distance = touchX - event.changedTouches[0].clientX;
      if (Math.abs(distance) > 40) window.heroGo(distance > 0 ? heroIndex + 1 : heroIndex - 1);
      start();
    }, { passive: true });
    start();
  }

  window.bGo = function (number) {
    var track = document.getElementById('bTrack');
    if (!track || !track.children.length) return;
    var count = track.children.length;
    var section = document.getElementById('benefits');
    var duration = section ? parseInt(section.dataset.benefitDuration, 10) : 6000;
    if (!duration || duration < 1000) duration = 6000;
    window.bIdx = (number + count) % count;
    track.style.transform = 'translateX(-' + (window.bIdx * (100 / count)) + '%)';
    var dots = document.querySelectorAll('#benefits .bdot');
    dots.forEach(function (dot) {
      dot.classList.remove('on');
    });
    var activeDot = dots[window.bIdx];
    if (activeDot) {
      void activeDot.offsetWidth;
      activeDot.classList.add('on');
    }
    clearInterval(benefitTimer);
    benefitTimer = setInterval(function () { window.bGo(window.bIdx + 1); }, duration);
  };

  function initBenefits() {
    var track = document.getElementById('bTrack');
    if (!track) return;
    window.bGo(window.bIdx);
  }

  window.impTab = function (button, id) {
    var tabs = button.closest('.imp-tabs');
    var wrap = button.closest('.impact-wrap');
    if (!tabs || !wrap) return;
    tabs.querySelectorAll('.imp-tab').forEach(function (tab) { tab.classList.remove('on'); });
    button.classList.add('on');
    wrap.querySelectorAll('.imp-panel').forEach(function (panel) { panel.classList.remove('on'); });
    var panel = wrap.querySelector('#imp-' + id);
    if (panel) panel.classList.add('on');
  };

  window.toggleFaq = function (question) {
    var item = question.parentElement;
    if (!item) return;
    var wasOpen = item.classList.contains('open');
    document.querySelectorAll('#faq .faq-item').forEach(function (entry) {
      entry.classList.remove('open');
    });
    if (!wasOpen) item.classList.add('open');
  };

window.gfPay = function (mode) {
  var once = document.getElementById('payOnce');
  var split = document.getElementById('paySplit');
  var button = document.getElementById('btn12');
  var note = document.getElementById('payNote');
  if (!once || !split || !button || !note) return;
  if (mode === 'once') {
    once.classList.add('on');
    split.classList.remove('on');
    button.innerHTML = 'Reserve 12 Months &mdash; &euro;1,188 &rarr;';
    button.setAttribute('data-gfeel-variant', '12months');
    note.textContent = 'Full 12-month program, paid in a single payment.';
  } else {
    split.classList.add('on');
    once.classList.remove('on');
    button.innerHTML = 'Reserve 12 Months &mdash; 4 &times; &euro;297 &rarr;';
    button.setAttribute('data-gfeel-variant', '4x297');
    note.textContent = '€297 charged today, then once a month for 3 more months. No interest, no fees. Total €1,188.';
  }
};

  function initTestimonials() {
    var carousel = document.getElementById('teCarousel');
    if (!carousel || carousel.dataset.ready === 'true') return;
    carousel.dataset.ready = 'true';
    var cardWidth = 380;
    var autoTimer;
    function resetAuto() {
      clearInterval(autoTimer);
      autoTimer = setInterval(function () {
        if (carousel.scrollLeft + carousel.offsetWidth >= carousel.scrollWidth - 10) carousel.scrollLeft = 0;
        else carousel.scrollLeft += cardWidth;
      }, 4000);
    }
    window.teScroll = function (direction) {
      carousel.scrollLeft += direction * cardWidth;
      resetAuto();
    };
    var down = false;
    var startX = 0;
    var scrollStart = 0;
    carousel.addEventListener('mousedown', function (event) {
      down = true;
      startX = event.pageX;
      scrollStart = carousel.scrollLeft;
      carousel.classList.add('dragging');
    });
    ['mouseleave', 'mouseup'].forEach(function (name) {
      carousel.addEventListener(name, function () {
        down = false;
        carousel.classList.remove('dragging');
      });
    });
    carousel.addEventListener('mousemove', function (event) {
      if (!down) return;
      event.preventDefault();
      carousel.scrollLeft = scrollStart - (event.pageX - startX);
    });
    var touchX = 0;
    carousel.addEventListener('touchstart', function (event) {
      touchX = event.touches[0].clientX;
    }, { passive: true });
    carousel.addEventListener('touchend', function (event) {
      var distance = touchX - event.changedTouches[0].clientX;
      if (Math.abs(distance) > 50) window.teScroll(distance > 0 ? 1 : -1);
    }, { passive: true });
    resetAuto();
  }

  function initAll() {
    initParticles();
    initReveal();
    initHero();
    initBenefits();
    initTestimonials();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);

  window.addEventListener('scroll', function () {
    var geo = document.querySelector('#hero .h-geo');
    if (geo && window.scrollY < 800) geo.style.transform = 'translateY(' + (window.scrollY * 0.12) + 'px)';
  }, { passive: true });
})();

